document.addEventListener('DOMContentLoaded', function () {

    /* ==============================================
       1. PRELOADER
    ============================================== */
    const preloader = document.getElementById('preloader');
    if (preloader) {
        const hidePreloader = function () {
            preloader.classList.add('hidden');
        };
        window.addEventListener('load', function () {
            setTimeout(hidePreloader, 1800);
        });
        // Fallback in case load event already fired or takes too long
        setTimeout(hidePreloader, 3000);
    }

    /* ==============================================
       2. HERO STARS
    ============================================== */
    /* ===== ANIMATED STARRY SKY CANVAS ===== */
    function initStarCanvas(canvasId, starCount) {
        const canvas = document.getElementById(canvasId);
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        let w, h, stars = [], animId;

        function resize() {
            var rect = canvas.parentElement.getBoundingClientRect();
            var pw = rect.width || canvas.parentElement.offsetWidth || window.innerWidth;
            var ph = rect.height || canvas.parentElement.offsetHeight || window.innerHeight;
            w = canvas.width = Math.round(pw);
            h = canvas.height = Math.round(ph);
        }

        function createStars() {
            stars = [];
            for (let i = 0; i < starCount; i++) {
                const brightness = Math.random();
                stars.push({
                    x: Math.random() * w,
                    y: Math.random() * h,
                    r: Math.random() * 1.8 + 0.3,
                    alpha: Math.random() * 0.6 + 0.2,
                    twinkleSpeed: Math.random() * 0.015 + 0.003,
                    twinkleOffset: Math.random() * Math.PI * 2,
                    driftX: (Math.random() - 0.5) * 0.08,
                    driftY: (Math.random() - 0.5) * 0.03,
                    color: brightness > 0.85
                        ? 'rgba(180,210,255,' // blue-white bright stars
                        : brightness > 0.6
                        ? 'rgba(200,220,255,' // blue-ish
                        : 'rgba(255,255,255,' // white
                });
            }
        }

        let time = 0;
        function draw() {
            ctx.clearRect(0, 0, w, h);
            time += 0.016;
            for (let i = 0; i < stars.length; i++) {
                const s = stars[i];
                // Twinkling
                const twinkle = Math.sin(time * s.twinkleSpeed * 60 + s.twinkleOffset);
                const a = s.alpha + twinkle * 0.3;
                const clampA = Math.max(0.05, Math.min(1, a));

                // Slow drift
                s.x += s.driftX;
                s.y += s.driftY;
                if (s.x < -5) s.x = w + 5;
                if (s.x > w + 5) s.x = -5;
                if (s.y < -5) s.y = h + 5;
                if (s.y > h + 5) s.y = -5;

                // Glow for bright stars
                if (s.r > 1.2 && clampA > 0.5) {
                    ctx.beginPath();
                    ctx.arc(s.x, s.y, s.r * 3, 0, Math.PI * 2);
                    ctx.fillStyle = s.color + (clampA * 0.15).toFixed(3) + ')';
                    ctx.fill();
                }

                ctx.beginPath();
                ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
                ctx.fillStyle = s.color + clampA.toFixed(3) + ')';
                ctx.fill();
            }
            animId = requestAnimationFrame(draw);
        }

        function start() {
            resize();
            if (w > 0 && h > 0) {
                createStars();
                draw();
            } else {
                setTimeout(start, 100);
            }
        }

        // Start after a brief delay to ensure layout is computed
        setTimeout(start, 50);

        window.addEventListener('resize', function() {
            resize();
            createStars();
        });
    }

    // Footer: dense stars at bottom, fading to top
    (function initFooterStars() {
        var canvas = document.getElementById('footer-canvas');
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        var w, h, stars = [];

        function resize() {
            var rect = canvas.parentElement.getBoundingClientRect();
            w = canvas.width = Math.round(rect.width || window.innerWidth);
            h = canvas.height = Math.round(rect.height || 500);
        }

        function createStars() {
            stars = [];
            for (var i = 0; i < 350; i++) {
                // Heavy bottom bias — pow(rand, 0.35) pushes most toward y=h
                var yRand = Math.pow(Math.random(), 0.35);
                var brightness = Math.random();
                stars.push({
                    x: Math.random() * w,
                    y: yRand * h,
                    r: Math.random() * 0.9 + 0.15,
                    alpha: Math.random() * 0.6 + 0.2,
                    twinkleSpeed: Math.random() * 0.015 + 0.003,
                    twinkleOffset: Math.random() * Math.PI * 2,
                    driftX: (Math.random() - 0.5) * 0.06,
                    driftY: (Math.random() - 0.5) * 0.02,
                    color: brightness > 0.85 ? 'rgba(180,210,255,' : brightness > 0.6 ? 'rgba(200,220,255,' : 'rgba(255,255,255,'
                });
            }
        }

        var time = 0;
        function draw() {
            ctx.clearRect(0, 0, w, h);
            time += 0.016;
            for (var i = 0; i < stars.length; i++) {
                var s = stars[i];
                var twinkle = Math.sin(time * s.twinkleSpeed * 60 + s.twinkleOffset);
                var a = s.alpha + twinkle * 0.25;
                // Fade out stars near the top (above 40%)
                var topFade = s.y < h * 0.4 ? (s.y / (h * 0.4)) * (s.y / (h * 0.4)) : 1;
                var clampA = Math.max(0.03, Math.min(1, a)) * topFade;

                s.x += s.driftX; s.y += s.driftY;
                if (s.x < -5) s.x = w + 5; if (s.x > w + 5) s.x = -5;
                if (s.y < -5) s.y = h + 5; if (s.y > h + 5) s.y = -5;

                if (s.r > 0.7 && clampA > 0.4) {
                    ctx.beginPath();
                    ctx.arc(s.x, s.y, s.r * 2.5, 0, Math.PI * 2);
                    ctx.fillStyle = s.color + (clampA * 0.08).toFixed(3) + ')';
                    ctx.fill();
                }
                ctx.beginPath();
                ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
                ctx.fillStyle = s.color + clampA.toFixed(3) + ')';
                ctx.fill();
            }
            requestAnimationFrame(draw);
        }

        function start() {
            resize();
            if (w > 0 && h > 0) { createStars(); draw(); }
            else setTimeout(start, 100);
        }
        setTimeout(start, 50);
        window.addEventListener('resize', function() { resize(); createStars(); });
    })();

    // Hero: bottom-heavy stars over video
    (function initHeroStars() {
        var canvas = document.getElementById('hero-stars-canvas');
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        var w, h, stars = [];

        function resize() {
            var rect = canvas.parentElement.getBoundingClientRect();
            w = canvas.width = Math.round(rect.width || window.innerWidth);
            h = canvas.height = Math.round(rect.height || window.innerHeight);
        }

        function createStars() {
            stars = [];
            for (var i = 0; i < 200; i++) {
                // Concentrate stars in bottom 60% — use power distribution
                var yRand = Math.pow(Math.random(), 0.4); // bias toward 1.0 (bottom)
                var brightness = Math.random();
                stars.push({
                    x: Math.random() * w,
                    y: yRand * h,
                    r: Math.random() * 1.6 + 0.3,
                    alpha: Math.random() * 0.5 + 0.15,
                    twinkleSpeed: Math.random() * 0.012 + 0.003,
                    twinkleOffset: Math.random() * Math.PI * 2,
                    driftX: (Math.random() - 0.5) * 0.06,
                    driftY: (Math.random() - 0.5) * 0.02,
                    color: brightness > 0.85 ? 'rgba(160,200,255,' : brightness > 0.6 ? 'rgba(180,210,255,' : 'rgba(255,255,255,'
                });
            }
        }

        var time = 0;
        function draw() {
            ctx.clearRect(0, 0, w, h);
            time += 0.016;
            for (var i = 0; i < stars.length; i++) {
                var s = stars[i];
                var twinkle = Math.sin(time * s.twinkleSpeed * 60 + s.twinkleOffset);
                var a = s.alpha + twinkle * 0.25;
                // Fade out stars near the top (above 30% height)
                var topFade = s.y < h * 0.3 ? (s.y / (h * 0.3)) : 1;
                var clampA = Math.max(0.03, Math.min(1, a)) * topFade;

                s.x += s.driftX;
                s.y += s.driftY;
                if (s.x < -5) s.x = w + 5;
                if (s.x > w + 5) s.x = -5;
                if (s.y < -5) s.y = h + 5;
                if (s.y > h + 5) s.y = -5;

                if (s.r > 1.2 && clampA > 0.4) {
                    ctx.beginPath();
                    ctx.arc(s.x, s.y, s.r * 3, 0, Math.PI * 2);
                    ctx.fillStyle = s.color + (clampA * 0.12).toFixed(3) + ')';
                    ctx.fill();
                }

                ctx.beginPath();
                ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
                ctx.fillStyle = s.color + clampA.toFixed(3) + ')';
                ctx.fill();
            }
            requestAnimationFrame(draw);
        }

        function start() {
            resize();
            if (w > 0 && h > 0) { createStars(); draw(); }
            else setTimeout(start, 100);
        }
        setTimeout(start, 50);
        window.addEventListener('resize', function() { resize(); createStars(); });
    })();

    /* ==============================================
       3. NASA STARS
    ============================================== */
    const nasaStars = document.getElementById('nasa-stars');
    if (nasaStars) {
        for (let i = 0; i < 120; i++) {
            const star = document.createElement('div');
            star.className = 'nasa-star';
            const size = Math.random() * 2 + 1;
            star.style.width = size + 'px';
            star.style.height = size + 'px';
            star.style.left = Math.random() * 100 + '%';
            star.style.top = Math.random() * 100 + '%';
            star.style.animationDuration = (Math.random() * 5 + 2) + 's';
            star.style.animationDelay = (Math.random() * 5) + 's';
            // Blue-ish white colors
            const colors = [
                'rgba(200,220,255,0.8)',
                'rgba(180,200,255,0.6)',
                'rgba(220,230,255,0.9)',
                'rgba(170,190,255,0.7)',
                'rgba(255,255,255,0.8)'
            ];
            star.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
            nasaStars.appendChild(star);
        }
    }

    /* ==============================================
       4. NAVBAR SCROLL
    ============================================== */
    const navbar = document.getElementById('navbar');
    const stickyBar = document.getElementById('sticky-bar');

    window.addEventListener('scroll', function () {
        const scrollY = window.scrollY;
        if (navbar) {
            if (scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        }
        if (stickyBar) {
            if (scrollY > 800) {
                stickyBar.style.display = '';
                stickyBar.classList.add('visible');
            } else {
                stickyBar.classList.remove('visible');
                stickyBar.style.display = 'none';
            }
        }
    });

    /* ==============================================
       5. MOBILE MENU
    ============================================== */
    const menuBtn = document.getElementById('menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');

    if (menuBtn && mobileMenu) {
        menuBtn.addEventListener('click', function () {
            menuBtn.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
        });

        // Close menu when clicking a link
        mobileMenu.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                menuBtn.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }

    /* ==============================================
       6. SMOOTH SCROLL
    ============================================== */
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            const target = document.querySelector(targetId);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });

    /* ==============================================
       7. SCROLL ANIMATIONS
    ============================================== */
    const animatedElements = document.querySelectorAll('[data-animate]');
    if (animatedElements.length > 0) {
        const animObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const delay = el.getAttribute('data-delay');
                    if (delay) {
                        setTimeout(function () {
                            el.classList.add('visible');
                        }, parseInt(delay, 10));
                    } else {
                        el.classList.add('visible');
                    }
                    animObserver.unobserve(el);
                }
            });
        }, { threshold: 0.1 });

        animatedElements.forEach(function (el) {
            animObserver.observe(el);
        });
    }

    /* ==============================================
       8. COUNTER ANIMATION
    ============================================== */
    const statNumbers = document.querySelectorAll('.stat-number[data-count]');
    if (statNumbers.length > 0) {
        const counterObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const target = parseInt(el.getAttribute('data-count'), 10);
                    const duration = 2000;
                    const startTime = performance.now();

                    function updateCounter(currentTime) {
                        const elapsed = currentTime - startTime;
                        const progress = Math.min(elapsed / duration, 1);
                        const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
                        el.textContent = Math.floor(eased * target);
                        if (progress < 1) {
                            requestAnimationFrame(updateCounter);
                        } else {
                            el.textContent = target;
                        }
                    }
                    requestAnimationFrame(updateCounter);
                    counterObserver.unobserve(el);
                }
            });
        }, { threshold: 0.1 });

        statNumbers.forEach(function (el) {
            counterObserver.observe(el);
        });
    }

    /* ==============================================
       9. SCIENCE BARS
    ============================================== */
    const scienceBars = document.querySelectorAll('.science-bar-fill');
    if (scienceBars.length > 0) {
        const barObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const width = el.getAttribute('data-width');
                    if (width) {
                        el.style.width = width + '%';
                    }
                    barObserver.unobserve(el);
                }
            });
        }, { threshold: 0.1 });

        scienceBars.forEach(function (el) {
            barObserver.observe(el);
        });
    }

    /* ==============================================
       10. HOW IT WORKS STEPS
    ============================================== */
    const hiwSteps = document.querySelectorAll('.how-step, .hiw-step');
    const hiwTemp = document.getElementById('hiw-temp');
    const temperatures = ['37\u00B0C', '38.5\u00B0C', '37\u00B0C', '36.8\u00B0C'];

    // Also look for temp display inside the how-it-works section
    const tempValueEl = document.querySelector('.temp-value');

    if (hiwSteps.length > 0) {
        const stepObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    el.classList.add('active');

                    // Determine step index
                    const stepNum = el.getAttribute('data-step');
                    const idx = stepNum ? parseInt(stepNum, 10) - 1 : Array.from(hiwSteps).indexOf(el);

                    if (idx >= 0 && idx < temperatures.length) {
                        if (hiwTemp) {
                            hiwTemp.textContent = temperatures[idx];
                        }
                        if (tempValueEl) {
                            tempValueEl.textContent = temperatures[idx];
                        }
                    }
                }
            });
        }, { threshold: 0.1 });

        hiwSteps.forEach(function (el) {
            stepObserver.observe(el);
        });
    }

    /* ==============================================
       11. PRODUCT FILTERS
    ============================================== */
    const filterBtns = document.querySelectorAll('.filter-btn');
    const productCards = document.querySelectorAll('.product-card');

    filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            // Update active state
            filterBtns.forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');

            const filter = btn.getAttribute('data-filter');

            productCards.forEach(function (card) {
                if (filter === 'all' || card.getAttribute('data-category') === filter) {
                    card.style.display = '';
                    card.classList.remove('hidden');
                } else {
                    card.style.display = 'none';
                    card.classList.add('hidden');
                }
            });
        });
    });

    /* ==============================================
       12. CART SYSTEM (Shopify AJAX API)
    ============================================== */
    function fmtPLN(n) {
        return (n / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' PLN';
    }

    function openCart() {
        var d = document.getElementById('cart-drawer');
        var o = document.getElementById('cart-overlay');
        if (d) d.classList.add('open');
        if (o) o.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeCart() {
        var d = document.getElementById('cart-drawer');
        var o = document.getElementById('cart-overlay');
        if (d) d.classList.remove('open');
        if (o) o.classList.remove('open');
        document.body.style.overflow = '';
    }

    function refreshCart() {
        return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
                renderCartFromShopify(cart);
                return cart;
            });
    }

    function renderCartFromShopify(cart) {
        var countEl = document.getElementById('cart-count');
        var totalEl = document.getElementById('cart-total');
        var itemsBox = document.getElementById('cart-items');
        if (countEl) {
            countEl.textContent = cart.item_count;
            countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        if (totalEl) totalEl.textContent = fmtPLN(cart.total_price);
        // Update free shipping note (conditional: hide motivator when threshold reached)
        var noteEl = document.querySelector('[data-free-ship-note]');
        if (noteEl) {
            var threshold = parseInt(noteEl.dataset.threshold || '39900', 10);
            if (cart.items_subtotal_price >= threshold) {
                noteEl.textContent = '✓ Masz darmową dostawę!';
                noteEl.style.color = '#5ac8fa';
            } else {
                var missing = threshold - cart.items_subtotal_price;
                noteEl.textContent = 'Darmowa dostawa od 399 PLN — brakuje ' + fmtPLN(missing);
                noteEl.style.color = '';
            }
        }
        if (itemsBox) {
            if (cart.items.length === 0) {
                itemsBox.innerHTML = '<div class="cart-empty">Twój koszyk jest pusty.</div>';
            } else {
                itemsBox.innerHTML = cart.items.map(function(item) {
                    var img = item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '';
                    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-line-variant">' + item.variant_title + '</span>' : '';
                    return '<div class="cart-line" data-key="' + item.key + '">' +
                        '<div class="cart-line-img">' + img + '</div>' +
                        '<div><div class="cart-line-name">' + item.product_title + '</div>' +
                        '<div class="cart-line-meta">' +
                            variant +
                            '<div class="cart-qty">' +
                                '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-action="decrease" aria-label="Zmniejsz">\u2212</button>' +
                                '<span class="cart-qty-val" data-key="' + item.key + '">' + item.quantity + '</span>' +
                                '<button type="button" class="cart-qty-btn" data-key="' + item.key + '" data-action="increase" aria-label="Zwiększ">+</button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="cart-line-price">' + fmtPLN(item.final_line_price) + '</div></div>' +
                        '<button class="cart-line-rm" data-key="' + item.key + '">&#10005;</button>' +
                        '</div>';
                }).join('');
            }
        }
    }

    function removeFromCart(key) {
        return fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(r) { return r.json(); }).then(function(cart) {
            renderCartFromShopify(cart);
            return cart;
        });
    }

    // Expose for inline scripts
    window.iqoneCart = { open: openCart, close: closeCart, refresh: refreshCart, render: renderCartFromShopify };

    // Event delegation
    document.addEventListener('click', function(e) {
        if (e.target.closest('#cart-btn')) {
            e.preventDefault();
            refreshCart().then(openCart);
            return;
        }
        if (e.target.closest('#cart-close') || e.target.closest('#cart-overlay')) {
            closeCart();
            return;
        }
        var rmBtn = e.target.closest('[data-key]');
        if (rmBtn && rmBtn.classList.contains('cart-line-rm')) {
            e.preventDefault();
            removeFromCart(rmBtn.getAttribute('data-key'));
            return;
        }
    });

    // Initialize cart on load
    refreshCart();

    /* ==============================================
       13. DISCOUNT POPUP (REMOVED)
    ============================================== */

    /* ==============================================
       14. NEWSLETTER FORMS — obsługiwane przez {% form 'customer' %} (Shopify), bez custom JS submit
    ============================================== */


    /* ==============================================
       15. PCM CROSS-SECTION CANVAS ANIMATION
    ============================================== */
    function initCross() {
        var canvas = document.getElementById('pcm-cross-canvas');
        if (!canvas) return;

        var section = canvas.closest('.pcm-cross-section');
        var ctx = canvas.getContext('2d');
        var phaseLabel = document.getElementById('pcm-cross-phase');

        var w, h;

        function resize() {
            w = section ? section.clientWidth : window.innerWidth;
            h = Math.min(section ? section.clientHeight : 400, 400);
            canvas.width = w;
            canvas.height = h;
        }
        resize();
        window.addEventListener('resize', resize);

        // Microcapsules — melt: 0=solid/big/touching (wall), 1=melted/small/moving (permeable)
        var capsules = [];
        // Dense irregular grid — capsules touch when solid
        var rows = 4;
        var cols = 14;
        for (var row = 0; row < rows; row++) {
            for (var col = 0; col < cols; col++) {
                // Offset odd rows for honeycomb-like packing
                var xShift = (row % 2 === 1) ? 0.5 / cols : 0;
                capsules.push({
                    x: 0.03 + (col / cols) * 0.94 + xShift + (Math.random() - 0.5) * 0.02,
                    y: 0.35 + (row / (rows - 1)) * 0.26 + (Math.random() - 0.5) * 0.02,
                    baseR: 12 + Math.random() * 4,
                    melt: 0,
                    offset: Math.random() * Math.PI * 2
                });
            }
        }

        var heatDots = [];
        var time = 0;
        var animRunning = false;

        // 2 phases: HOT (0-1) and COLD (1-2), smooth cycle
        // HOT: skin→PCM (capsules grow blue→orange), then once saturated PCM→otoczenie
        // COLD: otoczenie cools, PCM→skin (capsules shrink orange→blue)

        function draw() {
            if (!animRunning) return;
            ctx.clearRect(0, 0, w, h);

            var skinEnd = h * 0.30;
            var pcmTop = skinEnd;
            var pcmBot = h * 0.67;
            var envTop = pcmBot;

            // Smooth cycle: 0→1 HOT, 1→2 COLD
            var cycle = (time * 0.003) % 2;
            var isHot = cycle < 1;
            var progress = isHot ? cycle : cycle - 1;

            // Capsule target melt
            var meltTarget = isHot ? Math.min(progress * 1.5, 1) : Math.max(1 - progress * 1.5, 0);
            // Passthrough starts when capsules are >70% melted
            var saturated = meltTarget > 0.7;

            // Update phase label
            if (phaseLabel) {
                if (isHot && !saturated) {
                    phaseLabel.textContent = 'CIEPŁO — skóra oddaje ciepło → PCM absorbuje';
                    phaseLabel.style.color = 'rgba(255,160,60,0.9)';
                } else if (isHot && saturated) {
                    phaseLabel.textContent = 'NASYCENIE — PCM przepuszcza nadmiar ciepła do otoczenia';
                    phaseLabel.style.color = 'rgba(255,200,80,0.9)';
                } else {
                    phaseLabel.textContent = 'ZIMNO — PCM oddaje zmagazynowane ciepło do skóry';
                    phaseLabel.style.color = 'rgba(90,200,250,0.9)';
                }
            }

            // --- SKIN LAYER (warm orange glow, intensity varies) ---
            var skinHeat = isHot ? 0.15 + progress * 0.35 : 0.5 - progress * 0.35;
            var skinGrad = ctx.createLinearGradient(0, 0, 0, skinEnd);
            skinGrad.addColorStop(0, 'rgba(255,140,50,' + (skinHeat * 0.6) + ')');
            skinGrad.addColorStop(1, 'rgba(255,100,30,' + (skinHeat * 0.2) + ')');
            ctx.fillStyle = skinGrad;
            ctx.fillRect(0, 0, w, skinEnd);

            // --- PCM LAYER ---
            var pcmGrad = ctx.createLinearGradient(0, pcmTop, 0, pcmBot);
            pcmGrad.addColorStop(0, 'rgba(30,60,120,0.3)');
            pcmGrad.addColorStop(0.5, 'rgba(40,80,160,0.2)');
            pcmGrad.addColorStop(1, 'rgba(30,60,120,0.3)');
            ctx.fillStyle = pcmGrad;
            ctx.fillRect(0, pcmTop, w, pcmBot - pcmTop);

            // --- ENVIRONMENT LAYER ---
            var envHeat = (isHot && saturated) ? (meltTarget - 0.7) / 0.3 * 0.3 : 0;
            var envGrad = ctx.createLinearGradient(0, envTop, 0, h);
            envGrad.addColorStop(0, 'rgba(' + Math.round(30 + 50 * envHeat) + ',30,40,' + (0.2 + envHeat * 0.15) + ')');
            envGrad.addColorStop(1, 'rgba(20,20,30,0.4)');
            ctx.fillStyle = envGrad;
            ctx.fillRect(0, envTop, w, h - envTop);

            // --- Divider: Skin / PCM (thin dashed) ---
            ctx.setLineDash([8, 6]);
            ctx.strokeStyle = 'rgba(255,255,255,0.15)';
            ctx.lineWidth = 1;
            ctx.beginPath(); ctx.moveTo(0, skinEnd); ctx.lineTo(w, skinEnd); ctx.stroke();
            ctx.setLineDash([]);

            // --- BARRIER LINE: PCM / Otoczenie (thick, fades when saturated) ---
            var barrierOpacity;
            if (isHot) {
                // During hot phase: barrier fades as capsules saturate
                barrierOpacity = meltTarget < 0.7 ? 1.0 : Math.max(0, 1.0 - (meltTarget - 0.7) / 0.3);
            } else {
                // During cold phase: barrier reappears
                barrierOpacity = Math.min(1.0, progress * 2.5);
            }
            if (barrierOpacity > 0.01) {
                ctx.save();
                ctx.strokeStyle = 'rgba(90,200,250,' + (barrierOpacity * 0.7) + ')';
                ctx.lineWidth = 4;
                ctx.shadowColor = 'rgba(90,200,250,' + (barrierOpacity * 0.4) + ')';
                ctx.shadowBlur = 8;
                ctx.beginPath(); ctx.moveTo(0, pcmBot); ctx.lineTo(w, pcmBot); ctx.stroke();
                ctx.restore();
            }

            // --- MICROCAPSULES ---
            // melt=0: BIG, STILL, dense wall (blue) — blocks heat
            // melt=1: SMALL, moving, pulsing (orange) — permeable, heat passes through
            capsules.forEach(function(cap) {
                cap.melt += (meltTarget - cap.melt) * 0.03;

                // Movement scales with melt — 0=frozen, 1=fluid
                var moveFactor = cap.melt * cap.melt; // quadratic for snappier transition
                var floatY = (Math.sin(time * 0.02 + cap.offset) * 4 + Math.cos(time * 0.012 + cap.offset * 2.3) * 2.5) * moveFactor;
                var driftX = (Math.sin(time * 0.015 + cap.offset * 1.7) * 5 + Math.cos(time * 0.008 + cap.offset * 3.1) * 3) * moveFactor;
                var cx = cap.x * w + driftX;
                var cy = cap.y * h + floatY;

                // Size: BIG when solid (melt=0) — touching neighbors, SMALL when melted (melt=1)
                var pulse = Math.sin(time * 0.05 + cap.offset * 2) * 1.5 * moveFactor;
                var r = cap.baseR * (1.0 - cap.melt * 0.55) + pulse;

                // Color: blue(60,140,255) solid → orange(255,140,50) melted
                var cr = Math.round(60 + 195 * cap.melt);
                var cg = 140;
                var cb = Math.round(255 - 205 * cap.melt);
                var alpha = 0.6 + (1 - cap.melt) * 0.25; // more opaque when solid

                // Glow
                var glow = ctx.createRadialGradient(cx, cy, r * 0.3, cx, cy, r * 2);
                if (cap.melt > 0.5) {
                    glow.addColorStop(0, 'rgba(255,140,50,' + (cap.melt * 0.12) + ')');
                } else {
                    glow.addColorStop(0, 'rgba(60,140,255,' + ((1 - cap.melt) * 0.08) + ')');
                }
                glow.addColorStop(1, 'rgba(0,0,0,0)');
                ctx.fillStyle = glow;
                ctx.beginPath(); ctx.arc(cx, cy, r * 2, 0, Math.PI * 2); ctx.fill();

                // Ripple waves — expanding rings from center outward
                var rippleCount = 2;
                for (var ri = 0; ri < rippleCount; ri++) {
                    // Each ripple has its own phase, offset by capsule + ring index
                    var ripplePhase = ((time * 0.03 + cap.offset * 3 + ri * Math.PI) % (Math.PI * 2)) / (Math.PI * 2);
                    var rippleR = r + ripplePhase * r * 2.5;
                    var rippleAlpha = (1 - ripplePhase) * 0.25 * (0.3 + cap.melt * 0.7);
                    if (rippleAlpha > 0.01) {
                        ctx.beginPath();
                        ctx.arc(cx, cy, rippleR, 0, Math.PI * 2);
                        ctx.strokeStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + rippleAlpha + ')';
                        ctx.lineWidth = 1;
                        ctx.stroke();
                    }
                }

                // Shell
                ctx.beginPath();
                ctx.arc(cx, cy, r, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + alpha + ')';
                ctx.fill();
                ctx.strokeStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + Math.min(alpha + 0.2, 1) + ')';
                ctx.lineWidth = (1 - cap.melt) * 1.5 + 0.5;
                ctx.stroke();
            });

            // --- HEAT DOTS ---
            // HOT: skin → PCM (always during hot phase)
            if (isHot && Math.random() < 0.12) {
                heatDots.push({
                    x: Math.random() * 0.85 + 0.075,
                    y: 0.05, targetY: 0.50,
                    speed: 0.004 + Math.random() * 0.003,
                    life: 1, type: 'hot'
                });
            }
            // HOT saturated: PCM → otoczenie
            if (isHot && saturated && Math.random() < 0.15) {
                heatDots.push({
                    x: Math.random() * 0.85 + 0.075,
                    y: 0.60, targetY: 0.92,
                    speed: 0.003 + Math.random() * 0.003,
                    life: 1, type: 'pass'
                });
            }
            // COLD: PCM → skin
            if (!isHot && Math.random() < 0.12) {
                heatDots.push({
                    x: Math.random() * 0.85 + 0.075,
                    y: 0.50, targetY: 0.05,
                    speed: 0.004 + Math.random() * 0.003,
                    life: 1, type: 'cold'
                });
            }

            // Draw heat dots
            for (var d = heatDots.length - 1; d >= 0; d--) {
                var dot = heatDots[d];
                var dir = dot.targetY > dot.y ? 1 : -1;
                dot.y += dir * dot.speed;
                dot.life -= 0.008;

                if (dot.life <= 0 || (dir > 0 && dot.y > dot.targetY) || (dir < 0 && dot.y < dot.targetY)) {
                    heatDots.splice(d, 1);
                    continue;
                }

                var dc, dc2;
                if (dot.type === 'hot') {
                    dc = 'rgba(255,140,50,' + (dot.life * 0.8) + ')';
                    dc2 = 'rgba(255,200,100,' + dot.life + ')';
                } else if (dot.type === 'pass') {
                    dc = 'rgba(255,180,60,' + (dot.life * 0.6) + ')';
                    dc2 = 'rgba(255,220,120,' + (dot.life * 0.8) + ')';
                } else {
                    // COLD: PCM releases stored HEAT to skin — orange dots going up
                    dc = 'rgba(255,160,60,' + (dot.life * 0.8) + ')';
                    dc2 = 'rgba(255,200,100,' + dot.life + ')';
                }

                var dotGlow = ctx.createRadialGradient(dot.x * w, dot.y * h, 0, dot.x * w, dot.y * h, 8);
                dotGlow.addColorStop(0, dc);
                dotGlow.addColorStop(1, 'rgba(0,0,0,0)');
                ctx.fillStyle = dotGlow;
                ctx.fillRect(dot.x * w - 10, dot.y * h - 10, 20, 20);

                ctx.beginPath();
                ctx.arc(dot.x * w, dot.y * h, 2.5, 0, Math.PI * 2);
                ctx.fillStyle = dc2;
                ctx.fill();
            }

            time++;
            requestAnimationFrame(draw);
        }

        var crossObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !animRunning) {
                    animRunning = true;
                    resize();
                    draw();
                }
            });
        }, { threshold: 0.1 });

        crossObserver.observe(canvas);
    }

    initCross();

    /* ==============================================
       15b. TECH FIBER ANIMATION (Od kosmosu do szafy)
       Shows fabric fibers with PCM microcapsules embedded
    ============================================== */
    function initTechFiber() {
        var canvas = document.getElementById('tech-fiber-canvas');
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        var w, h;

        function resize() {
            w = canvas.parentElement ? canvas.parentElement.clientWidth : window.innerWidth;
            h = 400;
            canvas.width = w;
            canvas.height = h;
        }
        resize();
        window.addEventListener('resize', resize);

        // Create wavy fiber strands
        var fibers = [];
        for (var f = 0; f < 8; f++) {
            fibers.push({
                y: (f + 1) / 9,
                amplitude: 8 + Math.random() * 12,
                frequency: 0.008 + Math.random() * 0.006,
                phase: Math.random() * Math.PI * 2,
                thickness: 3 + Math.random() * 3
            });
        }

        // PCM capsules attached to fibers
        var caps = [];
        for (var c = 0; c < 50; c++) {
            var fiberIdx = Math.floor(Math.random() * fibers.length);
            caps.push({
                fiber: fiberIdx,
                xPos: Math.random(),
                baseR: 5 + Math.random() * 7,
                melt: 0,
                offset: Math.random() * Math.PI * 2
            });
        }

        // Heat particles
        var particles = [];
        var time = 0;
        var animRunning = false;

        function drawFiber() {
            if (!animRunning) return;
            ctx.clearRect(0, 0, w, h);

            // Phase cycle
            var cycle = (time * 0.003) % 2;
            var isHot = cycle < 1;
            var progress = isHot ? cycle : cycle - 1;
            var meltTarget = isHot ? Math.min(progress * 1.5, 1) : Math.max(1 - progress * 1.5, 0);

            // Background warmth
            var warmth = meltTarget * 0.15;
            ctx.fillStyle = 'rgba(' + Math.round(10 + warmth * 80) + ',' + Math.round(8 + warmth * 20) + ',' + Math.round(20 - warmth * 10) + ',0.4)';
            ctx.fillRect(0, 0, w, h);

            // Draw fiber strands
            fibers.forEach(function(fb) {
                ctx.beginPath();
                ctx.strokeStyle = 'rgba(255,255,255,0.06)';
                ctx.lineWidth = fb.thickness;
                for (var x = 0; x < w; x += 2) {
                    var fy = fb.y * h + Math.sin(x * fb.frequency + fb.phase + time * 0.008) * fb.amplitude;
                    if (x === 0) ctx.moveTo(x, fy);
                    else ctx.lineTo(x, fy);
                }
                ctx.stroke();
            });

            // Draw PCM capsules on fibers
            caps.forEach(function(cap) {
                cap.melt += (meltTarget - cap.melt) * 0.03;
                var fb = fibers[cap.fiber];
                var px = cap.xPos * w;
                var py = fb.y * h + Math.sin(px * fb.frequency + fb.phase + time * 0.008) * fb.amplitude;

                var moveFactor = cap.melt * cap.melt;
                var jitterX = Math.sin(time * 0.02 + cap.offset) * 3 * moveFactor;
                var jitterY = Math.cos(time * 0.015 + cap.offset * 2) * 2 * moveFactor;
                var cx = px + jitterX;
                var cy = py + jitterY;

                var pulse = Math.sin(time * 0.05 + cap.offset) * 1.0 * moveFactor;
                var r = cap.baseR * (1.0 - cap.melt * 0.4) + pulse;

                var cr = Math.round(60 + 195 * cap.melt);
                var cg = 140;
                var cb = Math.round(255 - 205 * cap.melt);
                var alpha = 0.5 + (1 - cap.melt) * 0.3;

                // Ripple
                var ripplePhase = ((time * 0.025 + cap.offset * 3) % (Math.PI * 2)) / (Math.PI * 2);
                var rippleR = r + ripplePhase * r * 2.5;
                var rippleAlpha = (1 - ripplePhase) * 0.18 * (0.2 + cap.melt * 0.8);
                if (rippleAlpha > 0.01) {
                    ctx.beginPath();
                    ctx.arc(cx, cy, rippleR, 0, Math.PI * 2);
                    ctx.strokeStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + rippleAlpha + ')';
                    ctx.lineWidth = 0.8;
                    ctx.stroke();
                }

                // Glow
                var glow = ctx.createRadialGradient(cx, cy, r * 0.2, cx, cy, r * 2);
                glow.addColorStop(0, 'rgba(' + cr + ',' + cg + ',' + cb + ',' + (cap.melt > 0.5 ? 0.15 : 0.08) + ')');
                glow.addColorStop(1, 'rgba(0,0,0,0)');
                ctx.fillStyle = glow;
                ctx.beginPath(); ctx.arc(cx, cy, r * 2, 0, Math.PI * 2); ctx.fill();

                // Shell
                ctx.beginPath();
                ctx.arc(cx, cy, r, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + alpha + ')';
                ctx.fill();
                ctx.strokeStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + Math.min(alpha + 0.2, 1) + ')';
                ctx.lineWidth = 1.2;
                ctx.stroke();
            });

            // Heat particles flowing through fibers
            if (Math.random() < 0.08) {
                var pFiber = fibers[Math.floor(Math.random() * fibers.length)];
                particles.push({
                    x: isHot ? 0 : w,
                    fiber: pFiber,
                    speed: (2 + Math.random() * 2) * (isHot ? 1 : -1),
                    life: 1,
                    hot: isHot
                });
            }
            for (var p = particles.length - 1; p >= 0; p--) {
                var pt = particles[p];
                pt.x += pt.speed;
                pt.life -= 0.005;
                var ptY = pt.fiber.y * h + Math.sin(pt.x * pt.fiber.frequency + pt.fiber.phase + time * 0.008) * pt.fiber.amplitude;
                if (pt.life <= 0 || pt.x < -20 || pt.x > w + 20) { particles.splice(p, 1); continue; }
                var pColor = pt.hot ? 'rgba(255,160,60,' + (pt.life * 0.6) + ')' : 'rgba(90,200,250,' + (pt.life * 0.6) + ')';
                ctx.beginPath();
                ctx.arc(pt.x, ptY, 2.5, 0, Math.PI * 2);
                ctx.fillStyle = pColor;
                ctx.fill();
            }

            // Phase label at bottom
            ctx.font = '11px Inter, sans-serif';
            ctx.textAlign = 'center';
            ctx.fillStyle = isHot ? 'rgba(255,160,60,0.6)' : 'rgba(90,200,250,0.6)';
            var label = isHot ? 'ABSORPCJA CIEPŁA — mikrokapsułki PCM topią się' : 'UWALNIANIE CIEPŁA — mikrokapsułki PCM krzepną';
            ctx.fillText(label, w / 2, h - 16);

            time++;
            requestAnimationFrame(drawFiber);
        }

        var fiberObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !animRunning) {
                    animRunning = true;
                    resize();
                    drawFiber();
                }
            });
        }, { threshold: 0.1 });
        fiberObserver.observe(canvas);
    }

    initTechFiber();

    /* ==============================================
       16. PCM WAVE CHART CANVAS
    ============================================== */
    function initWave() {
        var canvas = document.getElementById('pcm-wave-canvas');
        if (!canvas) return;

        var ctx = canvas.getContext('2d');
        var w = window.innerWidth - 80;
        var h = 250;
        canvas.width = w;
        canvas.height = h;

        window.addEventListener('resize', function () {
            w = window.innerWidth - 80;
            canvas.width = w;
        });

        var time = 0;
        var animRunning = false;

        function drawWave() {
            if (!animRunning) return;
            ctx.clearRect(0, 0, w, h);

            var comfortTop = h * 0.35;
            var comfortBottom = h * 0.65;

            // Comfort zone band — CYAN/blue
            ctx.fillStyle = 'rgba(90,200,250,0.08)';
            ctx.fillRect(0, comfortTop, w, comfortBottom - comfortTop);

            // Comfort zone borders
            ctx.setLineDash([6, 4]);
            ctx.strokeStyle = 'rgba(90,200,250,0.3)';
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(0, comfortTop);
            ctx.lineTo(w, comfortTop);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(0, comfortBottom);
            ctx.lineTo(w, comfortBottom);
            ctx.stroke();
            ctx.setLineDash([]);

            var mid = h * 0.5;
            var step = 2;

            // Regular clothing line — orange, large oscillations
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(255,140,50,0.8)';
            ctx.lineWidth = 2.5;
            for (var x = 0; x < w; x += step) {
                var y = mid + Math.sin((x + time * 2) * 0.015) * (h * 0.35)
                    + Math.sin((x + time * 1.5) * 0.025) * (h * 0.1);
                if (x === 0) {
                    ctx.moveTo(x, y);
                } else {
                    ctx.lineTo(x, y);
                }
            }
            ctx.stroke();

            // IQ ONE line — CYAN/blue, small oscillations within comfort zone, with glow
            ctx.save();
            ctx.shadowColor = 'rgba(90,200,250,0.5)';
            ctx.shadowBlur = 10;
            ctx.beginPath();
            ctx.strokeStyle = 'rgba(90,200,250,0.9)';
            ctx.lineWidth = 2.5;
            for (var x2 = 0; x2 < w; x2 += step) {
                var y2 = mid + Math.sin((x2 + time * 2) * 0.015) * (h * 0.08)
                    + Math.sin((x2 + time * 1.3) * 0.03) * (h * 0.04);
                if (x2 === 0) {
                    ctx.moveTo(x2, y2);
                } else {
                    ctx.lineTo(x2, y2);
                }
            }
            ctx.stroke();
            ctx.restore();

            time += 1;
            requestAnimationFrame(drawWave);
        }

        // Start on intersection
        var waveObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !animRunning) {
                    animRunning = true;
                    drawWave();
                }
            });
        }, { threshold: 0.1 });

        waveObserver.observe(canvas);
    }

    initWave();

    /* ==============================================
       16b. COSMOS WAVE BACKGROUND CANVAS
    ============================================== */
    function initCosmosWave() {
        var canvas = document.getElementById('cosmos-wave-canvas');
        if (!canvas) return;
        var ctx = canvas.getContext('2d');
        var w, h;

        function resize() {
            var rect = canvas.parentElement.getBoundingClientRect();
            w = canvas.width = Math.round(rect.width);
            h = canvas.height = Math.round(rect.height);
        }
        resize();
        window.addEventListener('resize', resize);

        var time = 0;
        var animRunning = false;

        // PCM microcapsules — start blue+big, absorb small particles, shrink and turn orange
        var capsules = [];
        for (var ci = 0; ci < 25; ci++) {
            capsules.push({
                x: Math.random() * 1200,
                lineIdx: Math.floor(Math.random() * 6),
                maxR: 8 + Math.random() * 8,
                charge: 0, // 0 = blue/cold, 1 = orange/full
                chargeSpeed: 0.0008 + Math.random() * 0.0006,
                speed: 0.2 + Math.random() * 0.3,
                offset: Math.random() * 1000
            });
        }

        // Small flowing particles that get absorbed
        var flows = [];
        for (var fi = 0; fi < 60; fi++) {
            flows.push({
                x: Math.random() * 1400,
                lineIdx: Math.floor(Math.random() * 6),
                speed: 1.2 + Math.random() * 1.5,
                alive: true,
                respawnTimer: 0,
                offset: Math.random() * 500
            });
        }

        function getLineY(x, lineIdx, mid, t) {
            var off = lineIdx * 55;
            return mid + Math.sin((x + t * 1.2 + off) * 0.008) * (h * 0.32)
                + Math.sin((x + t * 0.6 + off * 2) * 0.015) * (h * 0.12);
        }

        function lerpColor(charge) {
            // blue (60,140,240) -> orange (240,140,50)
            var r = Math.round(60 + charge * 180);
            var g = Math.round(140 + charge * 0);
            var b = Math.round(240 - charge * 190);
            return {r:r, g:g, b:b};
        }

        function draw() {
            if (!animRunning) return;
            ctx.clearRect(0, 0, w, h);

            var mid = h * 0.5;
            var step = 3;

            // Wave lines (fibers/threads)
            for (var line = 0; line < 6; line++) {
                ctx.beginPath();
                var alpha = 0.15 - line * 0.018;
                ctx.strokeStyle = 'rgba(180,190,210,' + alpha + ')';
                ctx.lineWidth = 1.2;
                for (var x = 0; x < w; x += step) {
                    var y = getLineY(x, line, mid, time);
                    if (x === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.stroke();
            }

            // Update and draw small flowing particles
            for (var fi2 = 0; fi2 < flows.length; fi2++) {
                var f = flows[fi2];
                if (!f.alive) {
                    f.respawnTimer--;
                    if (f.respawnTimer <= 0) {
                        f.alive = true;
                        f.x = -10 - Math.random() * 100;
                        f.lineIdx = Math.floor(Math.random() * 6);
                    }
                    continue;
                }
                f.x += f.speed;
                if (f.x > w + 20) { f.x = -10 - Math.random() * 50; f.lineIdx = Math.floor(Math.random() * 6); }
                var fy = getLineY(f.x, f.lineIdx, mid, time);

                // Check absorption by nearby capsule
                for (var ci2 = 0; ci2 < capsules.length; ci2++) {
                    var c = capsules[ci2];
                    if (c.charge >= 1) continue;
                    var dx = f.x - c.x;
                    var dy = fy - getLineY(c.x, c.lineIdx, mid, time);
                    var dist = Math.sqrt(dx * dx + dy * dy);
                    var absorbR = c.maxR * (1 - c.charge * 0.4) * 3;
                    if (dist < absorbR && Math.abs(f.lineIdx - c.lineIdx) <= 1) {
                        c.charge = Math.min(1, c.charge + 0.04);
                        f.alive = false;
                        f.respawnTimer = 30 + Math.floor(Math.random() * 40);
                        break;
                    }
                }

                if (f.alive) {
                    ctx.beginPath();
                    ctx.fillStyle = 'rgba(240,160,60,0.6)';
                    ctx.arc(f.x, fy, 1.8, 0, Math.PI * 2);
                    ctx.fill();
                }
            }

            // Draw capsules
            for (var ci3 = 0; ci3 < capsules.length; ci3++) {
                var cap = capsules[ci3];
                cap.x += cap.speed;
                if (cap.x > w + 30) {
                    cap.x = -20;
                    cap.charge = 0;
                    cap.lineIdx = Math.floor(Math.random() * 6);
                }

                // Slowly discharge when not absorbing
                if (cap.charge > 0) cap.charge = Math.max(0, cap.charge - 0.0003);

                var cy = getLineY(cap.x, cap.lineIdx, mid, time);
                var r = cap.maxR * (1 - cap.charge * 0.45);
                var col = lerpColor(cap.charge);

                // Glow
                ctx.beginPath();
                var grd = ctx.createRadialGradient(cap.x, cy, 0, cap.x, cy, r * 2.8);
                grd.addColorStop(0, 'rgba(' + col.r + ',' + col.g + ',' + col.b + ',0.25)');
                grd.addColorStop(1, 'rgba(' + col.r + ',' + col.g + ',' + col.b + ',0)');
                ctx.fillStyle = grd;
                ctx.arc(cap.x, cy, r * 2.8, 0, Math.PI * 2);
                ctx.fill();

                // Core
                ctx.beginPath();
                ctx.fillStyle = 'rgba(' + col.r + ',' + col.g + ',' + col.b + ',0.85)';
                ctx.arc(cap.x, cy, r, 0, Math.PI * 2);
                ctx.fill();
            }

            time += 1;
            requestAnimationFrame(draw);
        }

        var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && !animRunning) {
                    animRunning = true;
                    draw();
                }
            });
        }, { threshold: 0.1 });
        obs.observe(canvas);
    }
    initCosmosWave();

    /* ==============================================
       17. DYNAMIC URGENCY
    ============================================== */
    var urgencyEl = document.querySelector('.popup-urgency strong');
    if (urgencyEl) {
        setInterval(function () {
            urgencyEl.textContent = Math.floor(Math.random() * 50 + 10);
        }, 5000);
    }

    /* ==============================================
       18. CHECKOUT BUTTON
    ============================================== */
    var checkoutBtn = document.querySelector('.cart-checkout, .cart-checkout-btn');
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function () {
            if (Object.keys(cart).length === 0) {
                alert('Tw\u00F3j koszyk jest pusty. Dodaj produkt przed przej\u015Bciem do kasy.');
            } else {
                alert('Dzi\u0119kujemy! To jest wersja demo. W pe\u0142nej wersji zostaniesz przekierowany do kasy.');
            }
        });
    }

    /* ==============================================
       19. CART NEWSLETTER
    ============================================== */
    var cartNewsletterBtn = document.getElementById('cart-newsletter-btn');
    if (cartNewsletterBtn) {
        cartNewsletterBtn.addEventListener('click', function () {
            var email = prompt('Podaj sw\u00F3j adres e-mail, aby otrzyma\u0107 10% rabatu:');
            if (email && email.includes('@')) {
                this.parentElement.innerHTML = '<p style="color:#00d4ff;font-size:0.9rem;">Dzi\u0119kujemy! Kod rabatowy zosta\u0142 wys\u0142any na ' + email + '</p>';
            }
        });
    }

    // Also handle cart-newsletter click if no button with that ID
    var cartNewsletterDiv = document.querySelector('.cart-newsletter');
    if (cartNewsletterDiv && !cartNewsletterBtn) {
        cartNewsletterDiv.style.cursor = 'pointer';
        cartNewsletterDiv.addEventListener('click', function () {
            var email = prompt('Podaj sw\u00F3j adres e-mail, aby otrzyma\u0107 10% rabatu:');
            if (email && email.includes('@')) {
                this.innerHTML = '<p style="color:#00d4ff;font-size:0.9rem;">Dzi\u0119kujemy! Kod rabatowy zosta\u0142 wys\u0142any na ' + email + '</p>';
            }
        });
    }

    /* ==============================================
       20. PHASE TABS (Cztery fazy komfortu)
    ============================================== */
    var phaseTabs = document.querySelectorAll('.phase-tab');
    var phasePanels = document.querySelectorAll('.phase-panel');
    if (phaseTabs.length && phasePanels.length) {
        phaseTabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                var phase = this.getAttribute('data-phase');
                // Remove active from all tabs and panels
                phaseTabs.forEach(function (t) { t.classList.remove('active'); });
                phasePanels.forEach(function (p) { p.classList.remove('active'); });
                // Activate clicked tab and matching panel
                this.classList.add('active');
                var target = document.querySelector('.phase-panel[data-phase="' + phase + '"]');
                if (target) target.classList.add('active');
            });
        });
    }

    // Expose cart functions globally for potential external use
    window.openCart = openCart;
    window.closeCart = closeCart;
    window.addToCart = addToCart;
    window.removeFromCart = removeFromCart;

});
